module.exports = __webpack_public_path__ + "img/john_colins.e68ab557.jpg";